export default {
  items: [
    {
      name: 'Administración',
      url: '/admin',
      icon: 'icon-settings',
      map_state: 'map_state_admin',
      children: [
        {
          name: 'Roles',
          url: '/admin/roles',
          icon: 'icon-people',
          map_state: 'map_state_rols'
        },
        {
          name: 'Usuarios',
          url: '/admin/users',
          icon: 'icon-people',
          map_state: 'map_state_users'
        },
        {
          name: 'Usuarios Inactivos',
          url: '/admin/users/dels',
          icon: 'icon-people',
          map_state: 'map_state_udels'
        },
        /* {
          name: 'Colegios',
          url: '/admin/schools',
          icon: 'icon-graduation',
          map_state: 'map_state_schools'
        }, */
        {
          name: 'Carnetización',
          url: '/admin/carnets',
          icon: 'icon-credit-card',
          map_state: 'map_state_carnets'
        },        
        {
          name: 'Reportes recargas',
          url: '/admin/carnets/reports',
          icon: 'icon-credit-card',
          map_state: 'map_state_reports_carnets'
        },        
        {
          name: 'Carnetización cartera',
          url: '/admin/carnets/list_no_actions',
          icon: 'icon-credit-card',
          map_state: 'map_state_reports_carnets_no_actions'
        },
        {
          name: 'Recargar carnet',
          url: '/admin/validatecarnet',
          icon: 'icon-credit-card',
          map_state: 'map_state_reload_carnets'
        },
        {
          name: 'Descargar carnet',
          url: '/admin/validatecarnet/desc',
          icon: 'icon-credit-card',
          map_state: 'map_state_unload_carnets'
        }
      ]
    },
    {
      name: 'Academico',
      url: '/academic',
      icon: 'icon-graduation',
      map_state: 'map_state_academic',
      children: [
        {
          name: 'Estudiantes',
          url: '/academic/students',
          icon: 'icon-people',
          map_state: 'map_state_students'
        },
        {
          name: 'Acudientes',
          url: '/academic/attendant',
          icon: 'icon-people',
          map_state: 'map_state_attendant'
        },
        {
          name: 'Cursos',
          url: '/academic/courses',
          icon: 'icon-people',
          map_state: 'map_state_courses'
        },
        {
          name: 'Bloqueo de productos',
          url: '/academic/locks',
          icon: 'icon-people',
          map_state: 'map_state_locks'
        }
      ]
    },
    {
      name: 'Control de Acceso',
      url: '/controlacceso',
      icon: 'icon-settings',
      map_state: 'map_state_controlacceso',
      children: [
        {
          name: 'Acceso qr',
          url: '/controlacceso/qracces',
          icon: 'icon-people',
          map_state: 'map_state_qracces',
          map_state: 'map_state_qraccess'
        },
        {
          name: 'Permisos',
          url: '/controlacceso/permiss',
          icon: 'icon-graduation',
          map_state: 'map_state_permiss'
        },
        {
          name: 'Reportes',
          url: '/controlacceso/reports',
          icon: 'icon-credit-card',
          map_state: 'map_state_controlacceso_reports'
        },
        {
          name: 'Turnos Laborales',
          url: '/controlacceso/turns',
          icon: 'icon-credit-card',
          map_state: 'map_state_controlacceso_turns'
        }
      ]
    },
    /*{
      name: 'Inventario',
      url: '/inventory/products',
      icon: 'icon-grid',
      map_state: 'map_state_inventory',
      children: [
        {
          name: 'Proveedores',
          url: '/inventory/providers',
          icon: 'icon-user',
          map_state: 'map_state_providers'
        },
        {
          name: 'Reportes',
          url: '/inventory/reports',
          icon: 'icon-pie-chart',
          map_state: 'map_state_inventory_reports'
        }
      ]
    },*/
    {
      name: 'Cafeteria',
      url: '/cafeteria/requests',
      icon: 'icon-cup',
      map_state: 'map_state_cafeteria',
      children: [
        {
        name: 'Productos',
        url: '/cafeteria/products',
        icon: 'icon-star',
        map_state: 'map_state_inventory_products_papeleria',
        children: [
          {
                name: 'Categorias',
                url: '/inventory/products/categories',
                icon: 'icon-star',
                map_state: 'map_state_categories'
              },
              {
                name: 'Sub categorias',
                url: '/inventory/products/subcategories',
                icon: 'icon-star',
                map_state: 'map_state_subcategories'
              },
              {
                name: 'Productos',
                url: '/inventory/products',
                icon: 'icon-star',
                map_state: 'map_state_products'
              }
        ],
      },
      /*{
        name: 'Pedidos',
        url: '/cafeteria/requests',
        icon: 'icon-pin',
        map_state: 'map_state_cafeteria_requests'
      },*/
      {
        name: 'Pedidos QR',
        url: '/external/request',
        icon: 'icon-pin',
        map_state: 'map_state_external_requests'
      },
      {
        name: 'Alistamiento y entregas',
        url: '/external/list',
        icon: 'icon-cup',
        map_state: 'map_state_external',
        children: [
          {
            name: 'Alistamiento',
            url: '/external/list',
            icon: 'icon-pin',
            map_state: 'map_state_external_list'
          },
          {
            name: 'Turnero',
            url: '/turns',
            icon: 'icon-pin',
            map_state: 'map_state_external_turns'
          },
          {
            name: 'Entrega',
            url: '/external/entrega',
            icon: 'icon-pin',
            map_state: 'map_state_entrega'
          }
        ]
      },
      /*{
        name: 'Tabla Alistamiento',
        url: '/cafeteria/enlistment',
        icon: 'icon-action-redo',
        map_state: 'map_state_cafeteria_enlistment'
      },
      {
        name: 'Entregas',
        url: '/cafeteria/deliveries',
        icon: 'icon-like',
        map_state: 'map_state_cafeteria_deliveries'
      },*/
      // {
      //   name: 'Alistamiento',
      //   url: '/restaurant/external/list',
      //   icon: 'icon-pie-chart',
      //   map_state: 'map_state_alistamiento'
      // },
      /*{
        name: 'Turnero',
        url: '/turns',
        icon: 'icon-pie-chart',
        map_state: 'map_state_turns'
      },*/
      {
        name: 'Reportes',
        url: '/cafeteria/reports',
        icon: 'icon-pie-chart',
        map_state: 'map_state_cafeteria_reports'
      },
      
      {
        name: 'Reversion',
        url: '/cafeteria/reversion',
        icon: 'icon-pie-chart',
        map_state: 'map_state_cafeteria_reversion'
      },
      {
        name: 'Proveedores',
        url: '/inventory/providers',
        icon: 'icon-user',
        map_state: 'map_state_providers'
      },
      {
        name: 'Log de movimientos',
        url: '/inventory/reports',
        icon: 'icon-pie-chart',
        map_state: 'map_state_inventory_reports'
      }
      ]
    },
    {
      name: 'Papeleria',
      url: '/papeleria/requests',
      icon: 'fa fa-paperclip',
      map_state: 'map_state_papeleria',
      children: [
        {
          name: 'Productos',
          url: '/papeleria/products',
          icon: 'icon-star',
          map_state: 'map_state_inventory_products_papeleria',
          children: [
            {
              name: 'Categorias',
              url: '/papeleria/products/categories',
              icon: 'icon-star',
              map_state: 'map_state_categories_papeleria'
            },
            {
              name: 'Sub categorias',
              url: '/papeleria/products/subcategories',
              icon: 'icon-star',
              map_state: 'map_state_subcategories_papeleria'
            },
            {
              name: 'Productos',
              url: '/papeleria/products',
              icon: 'icon-star',
              map_state: 'map_state_products_papeleria'
            }
          ]
        },
        {
          name: 'Pedidos QR',
          url: '/papeleria/requests/create',
          icon: 'icon-pin',
          map_state: 'map_state_papeleria_requests'
        },
        {
          name: 'Entregas',
          url: '/papeleria/deliveries',
          icon: 'icon-like',
          map_state: 'map_state_papeleria_deliveries'
        },
        {
          name: 'Turnero',
          url: '/papeleria/turns',
          icon: 'icon-pie-chart',
          map_state: 'map_state_turnspapeleria'
        },
        {
          name: 'Reportes',
          url: '/papeleria/reports',
          icon: 'icon-pie-chart',
          map_state: 'map_state_papeleria_reports'
        },
        {
          name: 'Reversion',
          url: '/papeleria/reversion',
          icon: 'icon-pie-chart',
          map_state: 'map_state_papeleria_reversion'
        }
      ]
    },
    {
      name: 'Restaurante',
      url: '/restaurant/requests',
      icon: 'fa fa-cutlery',
      map_state: 'map_state_restaurante',
      children: [
        {
          name: 'Productos',
          url: '/restaurant/products',
          icon: 'icon-star',
          map_state: 'map_state_inventory_products',
          children: [
            {
              name: 'Categorias',
              url: '/restaurant/products/categories',
              icon: 'icon-star',
              map_state: 'map_state_categories'
            },
            {
              name: 'Sub categorias',
              url: '/restaurant/products/subcategories',
              icon: 'icon-star',
              map_state: 'map_state_subcategories'
            },
            {
              name: 'Productos',
              url: '/restaurant/products',
              icon: 'icon-star',
              map_state: 'map_state_products'
            }
          ]
        },
        {
          name: 'Categorias Usuarios',
          url: '/restaurant/categories',
          icon: 'icon-pin',
          map_state: 'map_state_restaurante_categories'
        },
        {
          name: 'Pedidos',
          url: '/restaurant/requests',
          icon: 'icon-pin',
          map_state: 'map_state_restaurante_requests'
        },
        {
          name: 'Alistamiento',
          url: '/restaurant/enlistment',
          icon: 'icon-action-redo',
          map_state: 'map_state_restaurant_enlistment'
        },
        {
          name: 'Entregas',
          url: '/restaurant/deliveries',
          icon: 'icon-like',
          map_state: 'map_state_restaurant_deliveries'
        },
        {
          name: 'Turnero',
          url: '/restaurante/turns',
          icon: 'icon-pie-chart',
          map_state: 'map_state_turnsrestaurante'
        },
        {
          name: 'Reversion',
          url: '/restaurant/reversion',
          icon: 'icon-pie-chart',
          map_state: 'map_state_restaurant_reversion'
        },
        {
          name: 'Reportes',
          url: '/restaurant/reports',
          icon: 'icon-pie-chart',
          map_state: 'map_state_restaurant_reports'
        }
      ]
    },
    {
      name: 'Rutas Escolares',
      url: '/schoolroutes/monitors',
      icon: 'icon-map',
      map_state: 'map_state_routes_head',
      children: [
        {
          name: 'Monitores',
          url: '/schoolroutes/monitors',
          icon: 'icon-people',
          map_state: 'map_state_monitors'
        },
        {
          name: 'Conductores',
          url: '/schoolroutes/drivers',
          icon: 'icon-people',
          map_state: 'map_state_drivers'
        },
        {
          name: 'Vehiculos',
          url: '/schoolroutes/vehicles',
          icon: 'icon-info',
          map_state: 'map_state_vehicles'
        },
        {
          name: 'Rutas',
          url: '/schoolroutes/routes',
          icon: 'icon-directions',
          map_state: 'map_state_routes'
        },
        {
          name: 'asigancion',
          url: '/schoolroutes/asignate',
          icon: 'icon-directions',
          map_state: 'map_state_asignate'
        },
        {
          name: 'Novedades',
          url: '/schoolroutes/news',
          icon: 'icon-book-open',
          map_state: 'map_state_news'
        },
        {
          name: 'Mensajeria',
          url: '/schoolroutes/messenger',
          icon: 'icon-speech',
          map_state: 'map_state_messenger'
        },
        {
          name: 'Reportes',
          url: '/schoolroutes/reports',
          icon: 'icon-pie-chart',
          map_state: 'map_state_schoolroutes_reports'
        }
      ]
    },
    {
      title: true,
      name: 'Components',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Base',
      url: '/base',
      icon: 'icon-puzzle',
      map_state: 'map_state_base',
      children: [
        {
          name: 'Typography',
          url: '/base/theme/typography',
          icon: 'icon-pencil',
          map_state: 'map_state_typography'
        },
        {
          name: 'Color',
          url: '/base/theme/colors',
          icon: 'icon-pencil',
          map_state: 'map_state_colors'
        },
        {
          name: 'Breadcrumbs',
          url: '/base/breadcrumbs',
          icon: 'icon-puzzle',
          map_state: 'map_state_breadcrumbs'
        },
        {
          name: 'Cards',
          url: '/base/cards',
          icon: 'icon-puzzle',
          map_state: 'map_state_cards'
        },
        {
          name: 'Carousels',
          url: '/base/carousels',
          icon: 'icon-puzzle',
          map_state: 'map_state_carousels'
        },
        {
          name: 'Collapses',
          url: '/base/collapses',
          icon: 'icon-puzzle',
          map_state: 'map_state_collapses'
        },
        {
          name: 'Forms',
          url: '/base/forms',
          icon: 'icon-puzzle',
          map_state: 'map_state_forms'
        },
        {
          name: 'Jumbotrons',
          url: '/base/jumbotrons',
          icon: 'icon-puzzle',
          map_state: 'map_state_jumbotrons'
        },
        {
          name: 'List Groups',
          url: '/base/list-groups',
          icon: 'icon-puzzle',
          map_state: 'map_state_groups'
        },
        {
          name: 'Navs',
          url: '/base/navs',
          icon: 'icon-puzzle',
          map_state: 'map_state_navs'
        },
        {
          name: 'Navbars',
          url: '/base/navbars',
          icon: 'icon-puzzle',
          map_state: 'map_state_navbars'
        },
        {
          name: 'Paginations',
          url: '/base/paginations',
          icon: 'icon-puzzle',
          map_state: 'map_state_paginations'
        },
        {
          name: 'Popovers',
          url: '/base/popovers',
          icon: 'icon-puzzle',
          map_state: 'map_state_popovers'
        },
        {
          name: 'Progress Bars',
          url: '/base/progress-bars',
          icon: 'icon-puzzle',
          map_state: 'map_state_bars'
        },
        {
          name: 'Switches',
          url: '/base/switches',
          icon: 'icon-puzzle',
          map_state: 'map_state_switches'
        },
        {
          name: 'Tables',
          url: '/base/tables',
          icon: 'icon-puzzle',
          map_state: 'map_state_tables'
        },
        {
          name: 'Tabs',
          url: '/base/tabs',
          icon: 'icon-puzzle',
          map_state: 'map_state_tabs'
        },
        {
          name: 'Tooltips',
          url: '/base/tooltips',
          icon: 'icon-puzzle',
          map_state: 'map_state_tooltips'
        },
        {
          name: 'Buttons',
          url: '/base/buttons',
          icon: 'icon-cursor',
          map_state: 'map_state_buttons',
          children: [
            {
              name: 'Buttons',
              url: '/base/buttons/standard-buttons',
              icon: 'icon-cursor',
              map_state: 'map_state_buttons'
            },
            {
              name: 'Button Dropdowns',
              url: '/base/buttons/dropdowns',
              icon: 'icon-cursor',
              map_state: 'map_state_dropdowns'
            },
            {
              name: 'Button Groups',
              url: '/base/buttons/button-groups',
              icon: 'icon-cursor',
              map_state: 'map_state_groups'
            },
            {
              name: 'Brand Buttons',
              url: '/base/buttons/brand-buttons',
              icon: 'icon-cursor',
              map_state: 'map_state_buttons'
            }
          ]
        },
        {
          name: 'Charts',
          url: '/base/charts',
          icon: 'icon-pie-chart',
          map_state: 'map_state_charts'
        },
        {
          name: 'Icons',
          url: '/base/icons',
          icon: 'icon-star',
          map_state: 'map_state_icons',
          children: [
            {
              name: 'CoreUI Icons',
              url: '/base/icons/coreui-icons',
              icon: 'icon-star',
              map_state: 'map_state_icons',
              badge: {
                variant: 'info',
                text: 'NEW'
              }
            },
            {
              name: 'Flags',
              url: '/base/icons/flags',
              icon: 'icon-star',
              map_state: 'map_state_flags'
            },
            {
              name: 'Font Awesome',
              url: '/base/icons/font-awesome',
              icon: 'icon-star',
              map_state: 'map_state_awesome',
              badge: {
                variant: 'secondary',
                text: '4.7'
              }
            },
            {
              name: 'Simple Line Icons',
              url: '/base/icons/simple-line-icons',
              icon: 'icon-star',
              map_state: 'map_state_icons'
            }
          ]
        },
        {
          name: 'Notifications',
          url: '/base/notifications',
          icon: 'icon-bell',
          map_state: 'map_state_notifications',
          children: [
            {
              name: 'Alerts',
              url: '/base/notifications/alerts',
              icon: 'icon-bell',
              map_state: 'map_state_alerts'
            },
            {
              name: 'Badges',
              url: '/base/notifications/badges',
              icon: 'icon-bell',
              map_state: 'map_state_badges'
            },
            {
              name: 'Modals',
              url: '/base/notifications/modals',
              icon: 'icon-bell',
              map_state: 'map_state_modals'
            }
          ]
        },
        {
          name: 'Widgets',
          url: '/base/widgets',
          icon: 'icon-calculator',
          map_state: 'map_state_widgets',
          badge: {
            variant: 'primary',
            text: 'NEW'
          }
        },
        {
          name: 'Pages',
          url: '/base/pages',
          icon: 'icon-star',
          map_state: 'map_state_pages',
          children: [
            {
              name: 'Error 404',
              url: '/base/pages/404',
              icon: 'icon-star',
              map_state: 'map_state_404'
            },
            {
              name: 'Error 500',
              url: '/base/pages/500',
              icon: 'icon-star',
              map_state: 'map_state_500'
            }
          ]
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js